import * as React from 'react';

import Markdown from 'markdown-to-jsx';

import useRouter from 'js/lib/useRouter';

import AnchorHeading from 'bundles/tutorials/components/AnchorHeading';
import BodyImage from 'bundles/tutorials/components/BodyImage';
import Code from 'bundles/tutorials/components/Code';
import CodePen from 'bundles/tutorials/components/CodePen';
import CodeSandBox from 'bundles/tutorials/components/CodeSandBox';
import Highlight from 'bundles/tutorials/components/Highlight';
import QuizSolution from 'bundles/tutorials/components/QuizSolution';
import TutorialLink from 'bundles/tutorials/components/TutorialLink';
import getContentComponents from 'bundles/tutorials/content-components';
import Rendered from 'bundles/tutorials/content-components/Rendered';

type Props = {
  children: string & React.ReactNode;
};

const TutorialMarkdown = ({ children: TutorialMarkdownChildren }: Props) => {
  const {
    params: { slug },
  } = useRouter();
  return (
    <Markdown
      options={{
        createElement(type, props, children) {
          // Overriding the default behaviour of wrapping the code element with pre tags since we have a custom component for Code blocks
          if (type === 'pre' && React.Children.only(children)) {
            return React.createElement('div', props, children);
          }
          // Adding a div wrapper with overflow x styling for responsive table elements
          if (type === 'table') {
            return React.createElement(
              'div',
              { style: { overflowX: 'auto' } },
              React.createElement(type, props, children)
            );
          }
          return React.createElement(type, props, children);
        },
        overrides: {
          h2: AnchorHeading,
          a: TutorialLink,
          img: BodyImage,
          code: Code,
          Highlight,
          QuizSolution,
          CodeSandBox,
          CodePen,
          Rendered,
          ...getContentComponents(slug),
        },
      }}
    >
      {TutorialMarkdownChildren}
    </Markdown>
  );
};

export default TutorialMarkdown;
